import { isEqual } from 'lodash'
import { Collection } from '@feedyou/utils'
import memoizeOne from 'memoize-one'
import cx from 'classnames'

import { confirm } from '../../lib/bootbox'
import { not } from '../../lib/functionChaining'
import { GenericFormData } from './types'
import { cleanEmptyProperties } from '../../lib/rjsf'

// Memo - minor perf improvement :)
// One memoized instance is enough, since we only use one settings popup at a time
// Note: order of arguments matters, because of memoization cache
const cleanEmptyPropertiesFromInitialFormData = memoizeOne(cleanEmptyProperties)
const cleanEmptyPropertiesFromCurrentFormData = memoizeOne(cleanEmptyProperties)
export const areFormDataEqual = memoizeOne(
  (initialFormData: GenericFormData = {}, currentFormData: GenericFormData = {}): boolean => {
    if (typeof initialFormData !== typeof currentFormData) {
      return false
    }

    if (typeof initialFormData === 'string' || typeof initialFormData === undefined) {
      return initialFormData === currentFormData
    }

    return isEqual(
      cleanEmptyPropertiesFromInitialFormData(initialFormData),
      cleanEmptyPropertiesFromCurrentFormData(currentFormData as object)
    )
  }
)

export function isWarning(validationMessage?: string): boolean {
  return !!validationMessage?.startsWith('Warning:')
}

export function hasValidationWarnings(validationMessages: Collection<string>): boolean {
  return Object.values(validationMessages).some(isWarning)
}

export function hasValidationErrors(validationMessages: Collection<string> = []): boolean {
  return Object.values(validationMessages).some(not(isWarning))
}

export const getFormClassList = (validationMessages: Collection<string>): string => {
  const shouldHaveWarningClass =
    hasValidationWarnings(validationMessages) && !hasValidationErrors(validationMessages)

  return cx(
    'reactjsonform', // I <3 PRETTIER
    { 'validation-warning': shouldHaveWarningClass }
  )
}

export async function confirmAboutChanges(close: () => void): Promise<void> {
  const isConfirmed = await confirm({
    title: '⚠️ Unsaved changes',
    message: 'You have made some changes. Do you really want to close the form and lose them?',
    buttons: {
      confirm: {
        label: 'Close anyway',
        className: 'btn-negative'
      }
    }
  })

  if (isConfirmed) {
    close()
  }
}
